if ( typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' ) {
	gsap.registerPlugin( ScrollTrigger );

	const cardDispensers = document.querySelectorAll( '.card-dispenser' );

	cardDispensers.forEach( ( dispenser ) => {
		const images = gsap.utils.toArray( '.card-dispenser__image', dispenser );
		const cards = gsap.utils.toArray( '.card-dispenser__card', dispenser );

		if ( images.length === 0 || cards.length === 0 ) {
			return;
		}

		images.forEach( ( el, i ) => {
			gsap.set( el, { zIndex: images.length - i } );
		} );

		gsap.set( images, {
			clipPath: 'inset(0% 0% 0% 0%)',
			webkitClipPath: 'inset(0% 0% 0% 0%)',
			willChange: 'clip-path',
		} );

		const mm = gsap.matchMedia();

		mm.add( '(min-width: 900px)', () => {
			cards.forEach( ( card, i ) => {
				const initialRotation = i % 2 === 0 ? -8 : 8;
				gsap.set( card, {
					rotation: initialRotation,
				} );
			} );
		} );

		mm.add( '(max-width: 899px)', () => {
			cards.forEach( ( card ) => {
				gsap.set( card, {
					rotation: 0,
				} );
			} );
		} );

		// Animation de la première image
		if ( images[ 0 ] ) {
			gsap.to( images[ 0 ], {
				scale: 1,
				scrollTrigger: {
					trigger: cards[ 0 ],
					start: 'top bottom',
					end: 'bottom top',
					scrub: 0.1,
				},
			} );
		}

		cards.forEach( ( card, i ) => {
			const currentImage = images[ i ];
			const nextImage = images[ i + 1 ];

			if ( currentImage ) {
				mm.add( '(min-width: 900px)', () => {
					const rotationValue = i % 2 === 0 ? 4 : -4;
					gsap.to( card, {
						rotation: rotationValue,
						scrollTrigger: {
							trigger: card,
							start: 'center bottom',
							end: 'bottom top',
							scrub: 0.1,
						},
					} );
				} );

				mm.add( '(max-width: 899px)', () => {
					gsap.to( card, {
						rotation: 0,
						scrollTrigger: {
							trigger: card,
							start: 'center bottom',
							end: 'bottom top',
							scrub: 0.1,
						},
					} );
				} );

				// Animation du clip-path (sauf pour la dernière image)
				if ( i < images.length - 1 ) {
					gsap.to( currentImage, {
						clipPath: 'inset(0% 0% 0% 100%)',
						webkitClipPath: 'inset(0% 0% 0% 100%)',
						scrollTrigger: {
							trigger: card,
							start: 'top top-=100',
							endTrigger: cards[ i + 1 ],
							end: 'bottom+=100 bottom',
							scrub: 0.1,
						},
					} );
				}

				// Animation de l'image suivante
				if ( nextImage ) {
					gsap.to( nextImage, {
						scale: 1,
						scrollTrigger: {
							trigger: card,
							start: 'top top',
							endTrigger: cards[ i + 1 ],
							end: 'top top',
							scrub: 0.1,
						},
					} );
				}
			}

			// Effet de hover simple sur la carte
			card.addEventListener( 'mouseenter', () => {
				gsap.to( card, {
					scale: 1.02,
					duration: 0.3,
					ease: 'power2.out',
				} );
			} );

			card.addEventListener( 'mouseleave', () => {
				gsap.to( card, {
					scale: 1,
					duration: 0.3,
					ease: 'power2.out',
				} );
			} );
		} );
	} );
}

